import { Record } from 'immutable';

import CampaignRecord from 'records/campaign';
import PromotionRecord from 'records/promotion';

export default Record({
    action: null,
    campaign: CampaignRecord(),
    campaignId: null,
    communicationEmail: null,
    companyId: null,
    confirmationCode: null,
    confirmed: 0,
    createdAt: '',
    deliverable: null,
    disputeReason: null,
    email: '',
    id: null,
    ip: '',
    isPaid: false,
    name: null,
    platform: null,
    promotion: PromotionRecord(),
    promotionId: null,
    ratings: null,
    reason: '',
    status: null,
});
